<template>
	<v-container fill-height fluid pa-0 style="height: 100vh">
		<v-layout row wrap>
			<v-flex md6 xs12>
				<v-carousel
					:interval="3000"
					class="login-slider"
					hide-controls
					hide-delimiters
					style="height: 100vh"
				>
					<v-carousel-item
						:key="i"
						:src="publicPath + 'login_slider2_' + i + '.jpg'"
						style="height: 100vh"
						v-for="i in 3"
					>
					</v-carousel-item>
				</v-carousel>
			</v-flex>
			<v-flex class="login-right" md6 pt-5 xs12>
				<v-layout>
					<v-spacer />
					<v-img :max-width="200" :src="publicPath + 'logo.png'" />
					<v-spacer />
				</v-layout>
				<v-layout class="mb-5 mt-5 pt-5" row wrap>
					<v-flex xs12>
						<div class="mb-1 display-1 text-xs-center">
							Client & Supplier<br />Management System
						</div>
					</v-flex>
				</v-layout>
				<v-layout class="pt-5" row wrap>
					<v-spacer></v-spacer>
					<v-flex md6 sm8 xs12>
						<v-card class="elevation-0" v-if="!forgottenPassword">
							<v-card-text>
								<InputField
									:error="loginValidation.email"
									:label="$t('fields.email')"
									:prependicon="'fa-user'"
									@keyup.native.enter="loginClick"
									v-model="loginData.email"
								></InputField>
								<InputField
									:error="loginValidation.password"
									:label="$t('fields.password')"
									:prependicon="'fa-envelope'"
									:type="'password'"
									@keyup.native.enter="loginClick"
									v-model="loginData.password"
								></InputField>
								<CheckBox
									:label="$t('fields.rememberMe')"
									v-model="loginData.remember_me"
								></CheckBox>
								<v-btn
									@click="forgottenPasswordClick"
									flat
									small
									>{{ $t("buttons.forgottenPassword") }}
								</v-btn>
							</v-card-text>
							<v-card-actions>
								<v-btn
									@click="registrationClick"
									v-if="$getSettings('REGISTRATION_ENABLED')"
								>
									<v-icon class="mr-2">fa-user-plus</v-icon>
									{{ $t("buttons.registration") }}
								</v-btn>
								<v-spacer></v-spacer>
								<v-btn @click="loginClick" class="mr-3">
									<v-icon class="mr-2">fa-sign-in-alt</v-icon>
									{{ $t("buttons.login") }}
								</v-btn>
								<div
									id="g_id_onload"
									:data-client_id="
										$getSettings('GOOGLE_LOGIN_CLIENT_ID')
									"
									data-context="signin"
									data-ux_mode="popup"
									data-callback="GLogin"
									data-auto_prompt="false"
								></div>
								<div
									class="g_id_signin"
									data-type="standard"
									data-shape="rectangular"
									data-theme="filled_black"
									data-text="signin_with"
									data-size="large"
									data-logo_alignment="left"
								></div>
							</v-card-actions>
						</v-card>
						<v-card class="elevation-0" v-if="forgottenPassword">
							<v-card-text>
								<InputField
									:error="forgottenEmailValidation"
									:label="$t('fields.email')"
									@keyup.native.enter="loginClick"
									v-model="forgottenEmail"
								></InputField>
								<div v-html="$t('texts.passwordReset')"></div>
							</v-card-text>
							<v-card-actions>
								<v-btn @click="forgottenPasswordBackClick">
									<v-icon class="mr-2">fa-arrow-left</v-icon>
									{{ $t("buttons.back") }}
								</v-btn>
								<v-spacer></v-spacer>
								<v-btn @click="forgottenPasswordSendClick">
									<v-icon class="mr-2">fa-paper-plane</v-icon>
									{{ $t("buttons.send") }}
								</v-btn>
							</v-card-actions>
						</v-card>
					</v-flex>
					<v-spacer></v-spacer>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import InputField from "./trinkets/InputField";
import CheckBox from "./trinkets/CheckBox";

export default {
	name: "Login",
	components: { CheckBox, InputField },
	data: function() {
		return {
			publicPath: process.env.BASE_URL,
			loginData: {
				email: "",
				password: "",
				remember_me: false
			},
			loginValidation: {
				email: "",
				password: ""
			},
			forgottenEmail: "",
			forgottenEmailValidation: "",
			forgottenPassword: false
		};
	},
	methods: {
		loginWithData(data) {
			this.$myStore.commit("setUser", data.user);
			this.$myStore.commit("setLoggedIn", true);
			this.$router.push("dashboard");
			if (data.version != this.$getCookie("malik_version")) {
				this.$setCookie("malik_version", data.version);
				window.location.reload(true);
			}
		},
		registrationClick() {
			this.$router.push("registration");
		},
		loginClick() {
			let success = true;

			if (this.loginData.email == "") {
				success = false;
				this.loginValidation.email = this.$t("alerts.emailMissing");
			} else {
				if (!this.$checkEmail(this.loginData.email)) {
					success = false;
					this.loginValidation.email = this.$t(
						"alerts.emailFailFormat"
					);
				} else {
					this.loginValidation.email = "";
				}
			}

			if (this.loginData.password == "") {
				success = false;
				this.loginValidation.password = this.$t(
					"alerts.passwordMissing"
				);
			} else {
				this.loginValidation.password = "";
			}

			if (success) {
				let vm = this;
				this.$APICall(
					"post",
					"login",
					this.loginData,
					(data, success) => {
						if (success) {
							vm.loginWithData(data);
						} else {
							if (data.internal_message != "account expired") {
								vm.$alert(vm.$t("alerts.loginFail"));
							} else {
								vm.$alert(vm.$t("alerts.accountExpired"));
							}
						}
					}
				);
			}
		},
		forgottenPasswordClick() {
			this.forgottenEmail = "";
			this.forgottenPassword = true;
		},
		forgottenPasswordBackClick() {
			this.forgottenEmail = "";
			this.forgottenPassword = false;
		},
		forgottenPasswordSendClick() {
			let success = true;

			if (this.forgottenEmail == "") {
				success = false;
				this.forgottenEmailValidation = this.$t("alerts.emailMissing");
			} else {
				if (!this.$checkEmail(this.forgottenEmail)) {
					success = false;
					this.forgottenEmailValidation = this.$t(
						"alerts.emailFailFormat"
					);
				} else {
					this.forgottenEmailValidation = "";
				}
			}

			if (success) {
				let vm = this;
				this.$APICall(
					"post",
					"password-recovery",
					{ email: this.forgottenEmail },
					(data, success) => {
						if (success) {
							vm.$alert(vm.$t("alerts.passwordResetSuccess"));
							this.forgottenEmail = "";
							this.forgottenPassword = false;
						} else {
							vm.$alert(vm.$t("alerts.passwordResetFail"));
						}
					}
				);
			}
		},
		resolveGoogleLogin(response) {
			let vm = this;
			let payload = {
				token: response.credential,
				remember_me: this.loginData.remember_me
			};
			this.$APICall("post", "google-login", payload, (data, success) => {
				if (success) {
					vm.loginWithData(data);
				} else {
					if (data.internal_message != "account expired") {
						vm.$alert(vm.$t("alerts.loginFail"));
					} else {
						vm.$alert(vm.$t("alerts.accountExpired"));
					}
				}
			});
		}
	},
	mounted() {
		this.$myStore.commit("setUser", null);
		this.$myStore.commit("setLoggedIn", false);

		const googleScript = document.createElement("script");
		googleScript.setAttribute(
			"src",
			"https://accounts.google.com/gsi/client"
		);
		document.head.appendChild(googleScript);
		window.GLogin = response => {
			this.resolveGoogleLogin(response);
		};
	}
};
</script>

<style scoped>
/deep/ .login-slider .v-image {
	height: 100vh !important;
}

.login-right {
	background: #ffffff;
}

</style>
